import styled from 'styled-components';
import { TappableArea as StyledTappableArea } from '../../fuse-tappable-area/src/tappablearea';

const StyledCheckbox = styled.div.attrs({
	className: 'fuse-checkbox__base-checkbox',
	'data-testid': 'fuse-checkbox__base-checkbox',
})`
	align-items: center;
	display: flex;
	height: fit-content;
`;

const StyledInput = styled.input
	.withConfig({ shouldForwardProp: (prop) => !['dataTestId'].includes(prop) })
	.attrs({
		className: 'fuse-checkbox__input',
		'data-testid': 'fuse-checkbox__input',
	})`
	opacity: 0;
	position: absolute;

	&& {
		outline: none;
	}
`;

const StyledLabel = styled.label.attrs({
	className: 'fuse-checkbox__label',
	'data-testid': 'fuse-checkbox__label',
})`
	color: var(--color-global-grey100);
	cursor: pointer;
	display: flex;
	flex: 1 1 auto;
	font-size: var(--font-size-1);
	font-weight: var(--font-weight-paragraph);
	position: relative;
`;

const StyledLabelTappableArea = styled.span.attrs({
	className: 'fuse-checkbox__tappable-area',
	'data-testid': 'fuse-checkbox__tappable-area',
})`
	display: flex;
	justify-content: space-between;
	width: 100%;
	${StyledTappableArea};
`;

export { StyledCheckbox, StyledInput, StyledLabel, StyledLabelTappableArea };
